import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import Alert from "../../components/Alert";
import PhotoUpload from "../../components/PhotoUpload";
import { getInstituteProfile, updateInstituteProfile, updateInstituteLogo } from "../../api/instituteApi";
import "../Users/UsersPage.css";
import "./InstituteProfilePage.css";

const emptyForm = {
  instituteName: "",
  address: "",
  adminName: "",
  contactNumber: "",
  instituteEmail: "",
  academicYear: "",
  eiinNo: "",
  deviceUserId: "",
  onlinePaymentStatus: 0,
  manualWaiverEnabled: false,
  imageName: null,
};

export default function InstituteProfilePage() {
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    getInstituteProfile()
      .then((data) => setForm({ ...emptyForm, ...data }))
      .catch(() => setError("Failed to load institute profile."))
      .finally(() => setLoading(false));
  }, []);

  const handleLogoUpload = async (file) => {
    const updated = await updateInstituteLogo(file);
    setForm({ ...emptyForm, ...updated });
    setSuccess("Logo updated.");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    setSuccess("");
    try {
      const updated = await updateInstituteProfile({
        ...form,
        onlinePaymentStatus: Number(form.onlinePaymentStatus),
      });
      setForm({ ...emptyForm, ...updated });
      setSuccess("Institute profile updated.");
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to update profile.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Institute Profile</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <form onSubmit={handleSubmit} className="user-form institute-profile-form">
          <label>Logo</label>
          <PhotoUpload folder="institute" fileName={form.imageName} onUpload={handleLogoUpload} />

          <label>Institute Name</label>
          <input
            value={form.instituteName}
            onChange={(e) => setForm({ ...form, instituteName: e.target.value })}
            required
          />

          <label>Address</label>
          <input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} required />

          <label>Admin Name</label>
          <input value={form.adminName} onChange={(e) => setForm({ ...form, adminName: e.target.value })} required />

          <label>Contact Number</label>
          <input
            value={form.contactNumber}
            onChange={(e) => setForm({ ...form, contactNumber: e.target.value })}
            required
          />

          <label>Institute Email</label>
          <input
            type="email"
            value={form.instituteEmail || ""}
            onChange={(e) => setForm({ ...form, instituteEmail: e.target.value })}
          />

          <label>Academic Year</label>
          <input
            value={form.academicYear || ""}
            onChange={(e) => setForm({ ...form, academicYear: e.target.value })}
          />

          <label>EIIN No</label>
          <input value={form.eiinNo || ""} onChange={(e) => setForm({ ...form, eiinNo: e.target.value })} />

          <label>Device User ID</label>
          <input
            value={form.deviceUserId || ""}
            onChange={(e) => setForm({ ...form, deviceUserId: e.target.value })}
          />

          <label>Online Payment Status</label>
          <select
            value={form.onlinePaymentStatus}
            onChange={(e) => setForm({ ...form, onlinePaymentStatus: e.target.value })}
          >
            <option value={1}>ON</option>
            <option value={0}>OFF</option>
          </select>

          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={form.manualWaiverEnabled}
              onChange={(e) => setForm({ ...form, manualWaiverEnabled: e.target.checked })}
            />
            Manual Waiver Enabled
          </label>

          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      )}
    </MainLayout>
  );
}
